import Broker from '../StepComponents/Broker';
import TypeOfContract from '../StepComponents/TypeOfContract';
import DateOfContract from '../StepComponents/DateOfContract';
import Supplier from '../StepComponents/Supplier';
import YearOfHarvest from '../StepComponents/YearOfHarvest';
import BuyingUnits from '../StepComponents/BuyingUnits';
import TransportTypes from '../StepComponents/TransportTypes';
import TransportPrice100Kg from '../StepComponents/TransportPrice100Kg';
import ValidUntill from '../StepComponents/ValidUntill';
import SupplierType from '../StepComponents/SupplierType';
import CertificateInfo from '../StepComponents/CertificateInfo';

export default function VertStepContent(props) {
    const displayCurrentStep = () => {
        console.log("Starting vert step: " + props.formComponentName);
        switch (props.formComponentName) {
            case "broker":
                return <Broker setContent={props.actions.setBroker} key={props.id} {...props}></Broker>
            case "typeOfContract":
                return <TypeOfContract setDataArea={props.actions.setDataArea} setContent={props.actions.setTypeOfContract} key={props.id} {...props}></TypeOfContract>
            case "dateOfContract":
                return <DateOfContract setContent={props.actions.setDateOfContract} key={props.id} {...props}></DateOfContract>
            case "supplierType":
                return <SupplierType setContent={props.actions.setSupplierType} key={props.id} {...props}></SupplierType>
            case "supplier":
                return <Supplier setContent={props.actions.setSupplier} key={props.id} {...props}></Supplier>
            case "yearOfHarvest":
                return <YearOfHarvest setContent={props.actions.setYear} setContent={props.actions.setYear} key={props.id} {...props}></YearOfHarvest>
            case "buyingUnits":
                return <BuyingUnits setContent={props.actions.setBuyingUnits} setDetailUOM={props.actions.setDetailUOM} key={props.id} {...props}></BuyingUnits>
            case "transportTypes":
                return <TransportTypes setContent={props.actions.setTransportType} key={props.id} {...props}></TransportTypes>
            case "transportPrice100Kg":
                return <TransportPrice100Kg setContent={props.actions.setTransportPrice100Kg} key={props.id} {...props}></TransportPrice100Kg>
            case "validUntill":
                return <ValidUntill setContent={props.actions.setValidUntillDate} key={props.id} {...props}></ValidUntill>
            case "certInfo":
                return <CertificateInfo setContent={props.actions.setCertInfo} key={props.id} {...props}></CertificateInfo>
        }
    }

    return (
        <div>
            {displayCurrentStep()}
        </div>
    )

}

